export const GET_DEATH_CERTIFICATE = 'DEATH_CERTIFICATE/get_user-_management';
export const GET_IMAGE = 'DEATH_CERTIFICATE/GET_IMAGE';
export const UPLOAD_NEW_IMAGE = 'DEATH_CERTIFICATE/UPLOAD_NEW_IMAGE';
export const UPDATE_NEW_IMAGE = 'DEATH_CERTIFICATE/UPDATE_NEW_IMAGE';
export const SYNC_TO_ES = 'DEATH_CERTIFICATE/SYNC_TO_ES';
export const GET_SINGLE_USER_MANAGEMENT =
  'DEATH_CERTIFICATE/get_single_user_management';
export const UPDATE_USER_MANAGEMENT =
  'DEATH_CERTIFICATE/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'DEATH_CERTIFICATE/create_brangay';
export const REMOVE_USER_MANAGEMENT =
  'DEATH_CERTIFICATE/remove_user_management';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  registry_number: '',
  first_name: '',
  middle_name: '',
  last_name: '',
  extension_name: '',
  death_date: '',
  sex: '',
  volume: '',
  front_page: '',
  back_page: '',
  front_page_file: '',
  back_page_file: '',
  place_of_death_municipality_code: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];

export const GET_REGION = 'OVRS/get_regions';
export const GET_PROVINCE = 'OVRS/get_provinces';
export const GET_MUNICIPALITIES = 'OVRS/get_municipalities';
export const GET_BARANGAYS = 'OVRS/get_barangays';

export const GENDER = [
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
  {
    label: 'MALE',
    value: 'MALE',
  },
];
